import React from 'react';
import { translate } from '@utils/i18n';
import { MainContentBanner } from '@components/MainContentBanner';
import { FireIcon } from '@icons/FireIcon';
const namespace = 'features.ia_promotion_banner';
const PRODUCT_PAGE_URL = 'https://www.inspectpoint.com/inspection-assistant-trial/';
export function IaPromotionBanner({ dismissKey }) {
    return (React.createElement(MainContentBanner, { title: translate('title', { namespace }), buttonTitle: translate('button_title', { namespace }), dismissTitle: translate('dismiss_banner', { namespace }), dismissKey: dismissKey, onClick: () => {
            window.open(PRODUCT_PAGE_URL, '_blank', 'noopener,noreferrer');
        }, icon: React.createElement(FireIcon, { width: 15, height: 18, color: "var(--blue-500)" }) }));
}
export default IaPromotionBanner;
